var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

import { Field, FieldLabel } from '../';

import MediaEditable from './MediaEditable';
import MediaPreview from './MediaPreview';

var LayoutMedia = (_temp = _class = function (_Component) {
    _inherits(LayoutMedia, _Component);

    function LayoutMedia() {
        _classCallCheck(this, LayoutMedia);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    LayoutMedia.prototype.render = function render() {
        var _props = this.props,
            media = _props.media,
            mediaId = _props.mediaId;


        var label = this.props.title || false;

        return React.createElement(
            Field,
            this.props,
            React.createElement(FieldLabel, { label: label }),
            React.createElement(
                MediaEditable,
                _extends({}, this.props, { media: media, mediaId: mediaId }),
                this.props.children
            )
        );
    };

    return LayoutMedia;
}(Component), _class.defaultProps = {
    editable: false,
    hotspot: false,
    content: false,
    mediaId: undefined,
    media: {}
}, _temp);


export default LayoutMedia;